/**
 * Sort bookings array by specified field and direction.
 * Supports date fields ('start', 'end') and other primitives.
 *
 * @param {Array} bookingsArray
 * @param {string} field - Field name to sort by
 * @param {string} direction - 'asc' or 'desc'
 * @returns {Array} - Sorted array
 */
export const sortBookings = (bookingsArray, field, direction) => {
  return [...bookingsArray].sort((a, b) => {
    // Handle date fields
    if (field === 'start' || field === 'end') {
      const dateA = new Date(a[field]);
      const dateB = new Date(b[field]);
      return direction === 'asc' ? dateA - dateB : dateB - dateA;
    }

    // Handle other primitive fields
    if (a[field] < b[field]) return direction === 'asc' ? -1 : 1;
    if (a[field] > b[field]) return direction === 'asc' ? 1 : -1;
    return 0;
  });
};
